export default {
  selectedWithCount: '{number} selected',
  shareEntireDirectory: 'Share & sync the entire folder',
  afterOpenTips:
    'Enable this option to share the entire folder and automatically include any new endpoints added to the folder.',
  afterOpenTipsTwo:
    'All the contents of the entire directory will be shared (New content in this directory will also be automatically shared in the future)',
  noContent: 'No Content',
  selectAll: 'Select All',
  all: 'All',
  notSelectAnyWithName: `No {name} selected`,
  cancel: 'Cancel',
  confirm: 'Confirm',
  customExpression: 'Custom Expression',
  noPermission: 'Insufficient permissions',
  enumeratedValue: 'Enums',
  description: 'Description',

  required: 'Required',
  optional: 'Optional',
  default: 'Default',
  length: 'Length',
  format: 'Format',
  enum: 'Enum',
  regexp: 'Regexp',
  and: 'and',
  value: 'Value',
  arrayLength: 'Length',
  uniqueItems: 'Item Unique',
  additionalItems: 'Additional Items',
  additionalProperties: 'Additional Properties',
  const: 'Const',
  multipleOf: 'Multiple of {multipleOf}',
  propertiesLength: 'Number of properties',
  writeOnly: 'Write Only',
  readOnly: 'Read Only',
  examples: 'Examples',
  externalDocs: 'External Docs',
  isCopied: 'Copied',
  copyToClipboard: 'Copy to clipboard',
  'overView.isCopied': 'Copied',
  'overView.failToCopied': 'Fail to copy, please manually record the following content',
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  deprecated: 'deprecated',
  'error.url': 'Invalid URL: {url}',
  note: 'NOTE',
  tip: 'TIP',
  info: 'INFO',
  caution: 'CAUTION',
  danger: 'DANGER',
  warning: 'WARNING',
  check: 'CHECK',
  name: 'Name',
  'codeEditor.copy': 'Copy',
  'codeEditor.format': 'Beautify',
  'codeEditor.showEditor': 'Show Content',

  'schemaGenerator.code': '',
  'schemaGenerator.codeGenerate': 'Generate schema code',
  'schemaGenerator.more': 'More',
  'schemaGenerator.name': 'Name',
  'schemaGenerator.commaSeparator': ', ',
  'codeEditor.wrap': 'Wrap',

  'inbox.MarkAllAsRead': 'Mark all as read',

  // markdown embed
  'githubGistRenderer.loading.message': 'Loading gist',
  'githubGistRenderer.errorLoading.message': 'Error loading gist',
};
